import { resumeDataSchema } from "@reactive-resume/schema";
import { kebabCase } from "@reactive-resume/utils";
import { createZodDto } from "nestjs-zod/dto";
import { z } from "nestjs-zod/z";

export const importResumeSchema = z.object({
  title: z.string().optional(),
  slug: z.string().min(1).transform(kebabCase).optional(),
  visibility: z.enum(["public", "private"]).default("private").optional(),
  data: resumeDataSchema,
});

export class ImportResumeDto extends createZodDto(importResumeSchema) {}

// 新增：用于接收resumejson数据和模板名称的Schema
export const generatePdfFromJsonResumeSchema = z.object({
  jsonResume: z.any(), // 接收任何JSON格式的数据，将由JsonResumeParser验证和转换
  templateName: z.string().optional(), // 可选的模板名称
});

export class GeneratePdfFromJsonResumeDto extends createZodDto(generatePdfFromJsonResumeSchema) {}
